import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import App from './App'
import './index.css'
import { initTheme } from './outline/theme.js'

// Apply saved/preferred theme before first render to avoid flash
initTheme()

// A Slack link straight to one meeting-notes import (?meetingImport=&importProject=, sent by
// api/meeting-notes-drafts.js). Captured here, before anything runs, because the outline rewrites
// the address on load to restore the last project and would drop it. TriageGate.jsx opens it.
try {
  const q = new URLSearchParams(window.location.search)
  if (q.get('meetingImport')) {
    sessionStorage.setItem('aj-open-import', JSON.stringify({ meetingId: q.get('meetingImport'), projectId: q.get('importProject') || '' }))
  }
} catch { /* storage blocked: the daily check still lists it */ }

// STALE-CHUNK GUARD (2026-08-11, Matt's "syntax error going into the modeler
// templates"): this app deploys many times a day, and Vite's hashed chunk names
// change with every build — a tab whose index.html predates the current deploy
// 404s when it lazy-loads a chunk (the SPA rewrite answers with text/html, which
// surfaces as a module-MIME error). Vite fires `vite:preloadError` for exactly
// this; one automatic reload picks up the fresh index. The sessionStorage flag
// stops a reload LOOP if the failure is something other than staleness — the
// second occurrence falls through to the normal (visible) error instead.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'aj-preload-error-reloaded'
  const last = Number(sessionStorage.getItem(KEY) || 0)
  // a reload within the last 30s already failed to fix it — let the error surface
  // (older stamps don't disarm the guard for the NEXT stale deploy weeks later)
  if (Date.now() - last < 30_000) return
  sessionStorage.setItem(KEY, String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY — copy .env.example to .env.local and fill in your key')
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <App />
    </ClerkProvider>
  </React.StrictMode>,
)
